export default "__VITE_ASSET__eCxaYn9I__"